import LabeledSelect from '../../../components/selects/LabeledSelect'
import { components } from 'react-select'
import { debounce, isEmpty } from 'lodash'
import { useCallback } from 'react'
import { getUserInfo } from 'redux/sagas/requests/nurseCampaignService'
import { getFullName } from 'helpers/helperFunctions'
import { requestUserSearch } from 'redux/sagas/requests/searchService'

const UserInfoSearchSelect = ({
  label,
  value,
  onChange,
  placeholder = 'Phone Number',
  emptyMsg = 'No data',
  isMin = false,
  ...props
}) => {

  const handleSearchUser = (input) => {
    if (isEmpty(input) || input.length !== 10) {
      return Promise.resolve([])
    }

    if(isMin){
      return requestUserSearch(input).then((response) =>
        response?.data && !isEmpty(response.data) ? [response.data] : [],
      )
    }else{
      return getUserInfo(input).then((response) =>
        response?.data && !isEmpty(response.data)? response.data : [],
      )
    }

  }

  // noinspection JSCheckFunctionSignatures
  const debouncedSearchUser = useCallback(
    debounce((inputText, callback) => {
      handleSearchUser(inputText).then((options) => callback(options))
    }, 500),
    [handleSearchUser],
  )

  return (
    <LabeledSelect
      label={label}
      value={value}
      getOptionLabel={(option) =>
        isMin ? `${getFullName(option.user_information)}, ${option.username}`:`${ getFullName(option)}, ${option.mobile}`
      }
      getOptionValue={(option) => option.id}
      placeholder={placeholder}
      onChange={onChange}
      emptyMsg={emptyMsg}
      {...props}
      loadOptions={debouncedSearchUser}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
        Input: (props) => <components.Input {...props} maxLength={10} />,
      }}
      noOptionsMessage={() => 'No Result'}
    />
  )
}

export default UserInfoSearchSelect
